import { Card, CardHeader, CardBody, Container, Row, Col, Button } from 'reactstrap';
import { Link, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import Content from './Content';
import { GET_SURVEY } from 'graphql/queries';
import { SURVEY_FULL_PATH } from 'constants/paths';
import { ResultContextProvider } from './ResultContext';
import { useState } from 'react';
import { endDate, startDate } from './constant';
import queryString from 'query-string';
import useWhiteLabel from 'hooks/useWhiteLabel';

const GivResultSurvey = (props) => {
  const { id } = useParams();

  const { isWhiteLabelTeam } = useWhiteLabel();

  const parsedQuery = queryString.parse(props.location.search);

  const [filterDateFrom, setFilterDateFrom] = useState(parsedQuery.start_date || startDate);

  const [filterDateUntil, setFilterDateUntil] = useState(parsedQuery.end_date || endDate);

  /**
   * TODO: move all filter to filterAnswers only. Don't need split to emoticonAnswers or presetDataAnswers
   */
  const [filterAnswers, setFilterAnswers] = useState();

  const [filterEmoticonAnswers, setFilterEmoticonAnswers] = useState();

  const [filterPresetDataAnswers, setFilterPresetDataAnswers] = useState();

  const { loading, data } = useQuery(GET_SURVEY, {
    variables: { id }
  });

  const isEmpty = !data?.getSurvey.lastResponse;

  return (
    <ResultContextProvider
      value={{
        filterDateFrom,
        setFilterDateFrom,
        filterDateUntil,
        setFilterDateUntil,
        filterAnswers,
        setFilterAnswers,
        filterEmoticonAnswers,
        setFilterEmoticonAnswers,
        filterPresetDataAnswers,
        setFilterPresetDataAnswers
      }}>
      <div
        className="header pb-7 d-flex align-items-center"
        style={{
          minHeight: '300px'
        }}>
        <span className="mask bg-brand opacity-8" />
        <Container fluid>
          <Row className="align-items-end">
            <Col xs="12" md="8">
              <h2 className="display-3 text-white d-print-none">
                {!isWhiteLabelTeam ? 'Gather ' : ''} Index Value
              </h2>
              <h3 className="text-white">{data?.getSurvey.name}</h3>
              <p className="text-white mt-0 mb-0 d-print-none">
                Our "{!isWhiteLabelTeam ? 'Gather ' : ''}Index Value" represents the mean average
                score of responses to the question set (emoticon only question types) as defined by
                the organisation. This value enables the business to easily see a summary value
                historically across any given period.
              </p>
              <p className="text-white mt-0 mb-0 font-weight-bold d-print-none">
                This capability enables an organisation to monitor and manage what's important to
                their organisation such as; customer satisfaction, business health, brand
                reputation, staff perspective, sentiment, well-being and more with just a single
                value. The organisation can also easily see which underlying questions are affecting
                this value.
              </p>
            </Col>
            <Col xs="12" md="4" className="mt-3 mt-md-0 text-md-right d-print-none">
              <div className="d-flex justify-content-end align-items-center">
                <Button
                  color="black"
                  size="sm"
                  className="rounded-pill mr-2"
                  onClick={async () => {
                    window.print();
                  }}>
                  Print Graphs
                </Button>
                <Link
                  to={`${SURVEY_FULL_PATH}/${id}/result`}
                  className="btn btn-neutral btn-sm rounded-pill flex-grow-1 flex-sm-grow-0"
                  color="default"
                  size="sm">
                  Back
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        {(loading || isEmpty) && (
          <Card>
            <CardHeader>
              <h3 className="mb-0 text-brand">Survey Results</h3>
            </CardHeader>
            <CardBody>
              <div className="text-center">
                {loading && <span>Loading...</span>}
                {!loading && isEmpty && <span>There aren't any responses!</span>}
              </div>
            </CardBody>
          </Card>
        )}

        {!loading && !isEmpty && <Content />}
      </Container>
    </ResultContextProvider>
  );
};

export default GivResultSurvey;
